import React from 'react';
import styled from 'styled-components';

import UnityHexagon from '../../UI/Animations/HeroHexagons/index';
import hexagonsDate from '../../UI/Animations/AnimationDate/lowerHexagonsDate';

const LowerHexagons = styled.div`
  min-width: 500px;
  z-index: 1;
`;

export const component = () => {
  const hexagons = hexagonsDate('ALL');
  return (
    <LowerHexagons>
      {hexagons ? hexagons.map(hexagon => <UnityHexagon {...hexagon} />) : ''}
    </LowerHexagons>
  );
};

export default component;



// WEBPACK FOOTER //
// ./src/components/Index/Hero/LowerHexagons.jsx